export enum TaskPriority {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}

export interface Task {
  _id: string;
  taskTypeId: string;
  priority: TaskPriority;
  userId: string;
  description: string;
  roomId: string;
  username: string;
  roomName: string;
  bookingId?: string;
  date: Date;
}
